<template>
  <div
    class="the-footer"
    ref="refRoot"
  >
    <div
      class="bg-black"
      :style="{
        '--gradientTopFrom': '80%',
        '--gradientTopTo': '100%',

        '--gradientBottomDirection': 'to top',
        '--gradientBottomFrom': '50%',
        '--gradientBottomTo': '100%',
      }"
    />
    <div class="the-container">
      <div class="the-grid">
        <div class="top">
          <LogoLarge class="logo" />
        </div>

        <ul
          v-for="group of footer.groups"
          :key="group._uid"
          class="group"
        >
          <div class="heading type-mono">{{ group.heading }}</div>
          <li
            v-for="item of group.items"
            :key="item._uid"
          >
            <Cta :blok="item">
              <HoverReveal>
                <span>{{ item.label }}</span>
              </HoverReveal>
            </Cta>
          </li>
        </ul>

        <div class="legal">
          {{ footer.legal }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LogoLarge from "@/icons/footer_logo.svg?skipsvgo"

const props = defineProps({})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

// ************************************************************************************
// DATA
// ************************************************************************************
const config = useRuntimeConfig()
let opts = {}
if (config.public.SB_VERSION == "draft") {
  opts.version = "draft"
}
const footerStory = await useStory("/global/the-footer", opts)
const footer = computed(() => footerStory.value?.content)

useDotsTrigger({
  trigger: refRoot,
  start: "top bottom",
  to: {
    ambientStrength: 0.8,
    flowMapStrength: 1,
    ambientMaskTop: 0,
    ambientMaskCenter: 0,
    ambientMaskBottom: 0,
  },
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.the-footer {
  position: relative;
  width: 100%;
  padding-top: 32.7rem;
  padding-bottom: 4.3rem;
  // border-top: 1px solid red; // DEBUG
}

.the-grid {
  // @include flex(column, flex-start, stretch);
}

.top {
  grid-column: 1 / -1;
  margin-bottom: 11rem;
}

.group {
  grid-row: 2;
  grid-column: auto / span 2;

  .heading {
    color: rgba($cl-light, 0.6);
    margin-bottom: 2.4rem;
  }

  .cta {
    display: block;
    margin-top: 1.2rem;

    :deep(.reveal-content) {
      @include gradientText();
    }
  }
}

.legal {
  grid-column: 10 / -1;
  @include flex(row, flex-end, flex-end);
  align-self: flex-end;
  color: rgba($cl-light, 0.6);
}

@include mobile {
  .the-footer {
    padding-top: 14rem;
    padding-bottom: 3.5rem;
  }

  .the-grid {
    gap: $p5;
  }

  .top {
    margin-bottom: calc(8rem - #{$p5});

    .logo {
      width: 100%;
    }
  }

  .group {
    grid-row: auto;

    .heading {
      margin-bottom: 1.2rem;
    }
  }

  .legal {
    grid-column: 1 / -1;
    display: block;
  }
}
</style>
